import clsx from "clsx";
import styles from "./DateModal.module.css";
import StartTimePicker from "./StartTimePicker";
import StartDatePicker from "./StartDatePicker";
import NextIcon from "../../../compoenets/atom/icons/NextIcon";
import EndTimePicker from "./EndTimePicker";
import EndDatePicker from "./EndDatePicker";
import { useDateModalContext } from "./DateModalContext";

interface DateTimeMainProps {
  expand: boolean;
}

const DateTimeMain: React.FC<DateTimeMainProps> = ({ expand }: DateTimeMainProps) => {
  const { isAllDay } = useDateModalContext();

  return (
    <div className={styles["date__total-datetime"]}>
      {/* Start DateTime Section */}
      <div
        className={clsx(styles["date__start-datetime"], {
          [styles["date__datetime--expand"]]: expand,
        })}
      >
        {!isAllDay && <StartTimePicker />}
        <StartDatePicker />
      </div>

      {/* Date Partition */}
      <div className={styles.date_partition}>
        <NextIcon color={"#fff"} />
      </div>

      {/* End DateTime Section */}
      <div
        className={clsx(styles["date__end-datetime"], {
          [styles["date__datetime--expand"]]: expand,
        })}
      >
        {!isAllDay && <EndTimePicker />}
        <EndDatePicker />
      </div>
    </div>
  );
};

export default DateTimeMain;
